import { sendCategoryFilterEvent } from '../../utils/event-triggers';
import { get } from '../../utils/object-helpers';

export default class {
    onInput(input) {
        return Object.assign(input, updateInput(input));
    }
    fetchCategoryListings(url, evt) {
        sendCategoryFilterEvent({ url, clickEvent: evt });
    }
}

function updateInput(input) {
    const quickviewFlag = get(input, 'moreOptions.action.clientPresentationMetadata.sf-quickview-atc-btn', null);
    let isSmall = get(input, 'isSmall', null);
    // Sometimes 'isSmall' is not passed in on input (TODO: See if we can always use page.isSmall instead.)
    if (isSmall === null) {
        isSmall = get(input, 'page.isSmall', false);
    }
    const action = get(input, 'action', {});
    const title = get(input, 'title', {});
    title.action = action;

    return {
        testId: getTestId(input),
        signal: getSignalData(input),
        itemCardWatch: getWatchData(input),
        trackingData: setTrackingData(input),
        propertyOrdering: arrangePropertyOrdering(input),
        openLinkInNewTab: get(input, 'action.name', '') === 'VIEW_ITEM' && !isSmall,
        isAjax: get(input, 'action.clientPresentationMetadata.ajax') === 'true',
        eekIcon: get(input, '__search.eekIcon', get(input, 'eekIcon', null)),
        sid: get(input, 'action.trackingList.[0].eventProperty.sid', ''),
        isQuickviewEnabled: quickviewFlag === '3' && !isSmall,
        imageSize: get(input, 'imageSize', 300),
        link: get(input, 'action.URL', null),
        itemId: get(input, 'listingId', ''),
        action: get(input, 'action', {}),
        isSmall: isSmall
    };
}

function getTestId(input) {
    const testId = get(input, 'testId', '');
    const testIdAttr = {};

    if (testId !== '') {
        testIdAttr['data-testid'] = testId;
    }

    return testIdAttr;
}

function setTrackingData(input) {
    let trackingData = get(input, 'action.trackingList.[1]', {});

    if (!Object.keys(trackingData).length) {
        trackingData = get(input, 'action.trackingList.[0]', {});
        return trackingData;
    }

    trackingData = JSON.stringify(trackingData);
    return trackingData;
}

function getWatchData(input) {
    const itemCardWatch = input.simplified ? null :
        get(input, '__search.defaultWatchIconAtCorner', null) ||
        get(input, '__search.defaultWatchIconOnImage', null);

    return itemCardWatch;
}

function getSignalData(input) {
    const hasUrgencySignal = get(input, '__search.hasUrgencySignal', false);
    const __signal = hasUrgencySignal && input.itemHotness ? {
        ...input.itemHotness,
        status: 'time-sensitive'
    } : null;

    return __signal;
}

function arrangePropertyOrdering(input) {
    const propertyOrdering = get(input, 'itemPropertyOrdering.DEFAULT', {});
    const titleTags = get(input, '__search.titleTags', {});
    const __signal = getSignalData(input);

    // Reorder where the image and title is rendered
    propertyOrdering.header = propertyOrdering.header || [['image']];
    propertyOrdering.primary = propertyOrdering.primary || [['title']];

    if (propertyOrdering.header.find(it => it.includes('title'))) {
        propertyOrdering.header.splice(['title']);
        propertyOrdering.primary.unshift(['title']);
    }
    if (!propertyOrdering.header.find(it => it.includes('image'))) {
        propertyOrdering.header.unshift(['image']);
    }
    if (titleTags && propertyOrdering?.caption?.find(it => it.includes('__search.titleTags'))) {
        propertyOrdering.caption = propertyOrdering.caption.filter(it => !it.includes('__search.titleTags'));
        propertyOrdering.primary.unshift(['__search.titleTags']);
    }

    // Reorder where __signal is rendered
    if (__signal && !input.simplified) {
        const currentItemHotnessIdx = propertyOrdering.primary.findIndex(it => it.includes('itemHotness'));
        if (currentItemHotnessIdx !== -1) {
            propertyOrdering.primary.splice(currentItemHotnessIdx, 1);
        }
        if (!propertyOrdering.header.find(it => it.includes('__signal'))) {
            propertyOrdering.header.splice(1, 0, ['__signal']);
        }
    }

    return propertyOrdering;
}
